// src/foundation/color/hanghae.ts
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var _obj;
var hanghae = (_obj = {}, _define_property(_obj, "red120" /* Red120 */ , "#BB150F"), _define_property(_obj, "red100" /* Red100 */ , "#DE1912"), _define_property(_obj, "red60" /* Red60 */ , "#FF5C5C"), _define_property(_obj, "red40" /* Red40 */ , "#FF8F8F"), _define_property(_obj, "red20" /* Red20 */ , "#FFC2C2"), _define_property(_obj, "red0" /* Red0 */ , "#FFEBEB"), _obj);
export { hanghae };
